import './src/styles/main.css'